import auth from "@/helper/middleware/auth";
import admin from "@/helper/middleware/admin";

export default [
  {
    path: "/members",
    name: "users",
    component: () => import("@/views/users/UsersView.vue"),
    meta: { middleware: [auth, admin] },
  },
];
